// Logo Assietica Soc.Coop. Società Benefit
const LOGO = "/assets/assietica-logo.png";
const ICON = "/assets/assietica-icon.png";

export function Brand({ compact = false, light = false }) {
  if (light) {
    // Sfondo scuro: il testo del logo (blu navy) non sarebbe leggibile → icona colorata + wordmark bianco
    return (
      <div className="flex items-center gap-2.5" data-testid="brand-logo">
        <img src={ICON} alt="Assietica" className="h-10 w-10 object-contain" />
        <div className="leading-tight">
          <div className="font-heading text-[15px] font-semibold tracking-tight text-white">Portale Partner</div>
          <div className="text-[11px] font-medium text-white/75">Assietica Soc.Coop.</div>
        </div>
      </div>
    );
  }
  if (compact) {
    return (
      <div className="flex items-center" data-testid="brand-logo">
        <img src={ICON} alt="Assietica" className="h-9 w-9 object-contain" />
      </div>
    );
  }
  return (
    <div className="flex items-center" data-testid="brand-logo">
      <img src={LOGO} alt="Assietica Soc.Coop. Società Benefit" className="h-10 w-auto object-contain" />
    </div>
  );
}
